// extracted by mini-css-extract-plugin
module.exports = {"docsList":"Documents_docsList__3npPW","button":"Documents_button__rNoew","newSimulation":"Documents_newSimulation__Q6d8q"};